import { render, staticRenderFns } from "./Wenzhangliebiao.vue?vue&type=template&id=01f7c956&scoped=true&"
import script from "./Wenzhangliebiao.vue?vue&type=script&lang=js&"
export * from "./Wenzhangliebiao.vue?vue&type=script&lang=js&"
import style0 from "./Wenzhangliebiao.vue?vue&type=style&index=0&id=01f7c956&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f7c956",
  null
  
)

export default component.exports